import Reveal from "@/components/Reveal";

export default function Premio({ t }) {
  return (
    <section data-testid="premio-section" className="py-14 sm:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-center gap-7 sm:gap-10 rounded-3xl border border-[#C39A48]/30 bg-[#F3ECE0] px-6 sm:px-10 py-8 sm:py-10">
            <img
              src="/images/premio-gambero.jpg"
              alt="Cono Fiordipanna davanti al cartello del Premio Speciale Gambero Rosso"
              data-testid="premio-image"
              loading="lazy"
              className="w-44 sm:w-52 aspect-[3/4] object-cover rounded-2xl -rotate-2 shadow-xl shadow-[#1E1614]/20 shrink-0"
            />
            <div className="text-center sm:text-left">
              <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-3">
                {t.premio.over}
              </p>
              <h2 className="font-display tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#241C1A] leading-[1.15]">
                {t.premio.titleA}
                <em className="text-[#C86D51]">{t.premio.titleEm}</em>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-[#6E625E] max-w-lg">
                {t.premio.text}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
